import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type SiteVisitDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const SiteVisitDetails = ({ control }: SiteVisitDetailsProps) => {
  const { errors } = useFormState({
    control,
  });

  const {
    general: { siteVisitStartDate, siteVisitEndDate } = {
      siteVisitStartDate: undefined,
      siteVisitEndDate: undefined,
    },
  } = useWatch({
    control,
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <AccessTimeIcon fontSize="inherit" />
            <span>&nbsp;Site visit date</span>
          </Grid>
        </Typography>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Start:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.siteVisitStartDate
                ? 'error'
                : isNil(siteVisitStartDate)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {siteVisitStartDate
              ? new Date(siteVisitStartDate).toLocaleString()
              : '—'}
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            End:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.siteVisitEndDate
                ? 'error'
                : isNil(siteVisitEndDate)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {siteVisitEndDate
              ? new Date(siteVisitEndDate).toLocaleString()
              : '—'}
          </Typography>
        </Grid>
        <Divider />
      </Stack>
    </Box>
  );
};
